import { useState } from 'react';

import type { TLeasingOrderResponse } from '@/components/App/Leasing/types';
import { OfferCard } from '@/components/Shared/ui';

import { LeasingDetails } from '../../ui';

type TLeasingWaitingItemProps = {
  leasingOffer: TLeasingOrderResponse;
};

const LeasingWaitingItem = ({ leasingOffer }: TLeasingWaitingItemProps) => {
  const [isLeasingDetailsModalOpen, setIsLeasingDetailsModalOpen] =
    useState(false);

  return (
    <>
      <OfferCard
        className="ie-leasing-item"
        status="warning"
        statusText={leasingOffer.status.name}
      >
        <OfferCard.Header
          title={leasingOffer.leasingCompany.name}
          icon={leasingOffer.leasingCompany.icon}
          isWaitingOffer
          descriptionAction={
            leasingOffer.comment
              ? {
                  onClick: () => setIsLeasingDetailsModalOpen(true),
                  text: <span className="ie-offer-step__hidden">Описание</span>
                }
              : undefined
          }
        />
      </OfferCard>

      <LeasingDetails
        isModalOpen={isLeasingDetailsModalOpen}
        onClose={() => setIsLeasingDetailsModalOpen(false)}
        leasingOffer={leasingOffer}
      />
    </>
  );
};

export default LeasingWaitingItem;
